
import {
  defineComponent, onBeforeUnmount, PropType, ref,
} from 'vue'
import axios from 'axios'
import { useI18n } from 'vue-i18n'
import IconEye from '@/vue/icons/IconEye.vue'
import IconEyeSlash from '@/vue/icons/IconEyeSlash.vue'
import periodic from '@/scripts/periodic'
import { request } from '@/scripts/combinedRequest'
import { Button } from '@/types/webinar.d'

export default defineComponent({
  name: 'AdminButtons',
  components: { IconEyeSlash, IconEye },
  props: {
    scheduleId: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18n()

    const buttons = ref<Button[]>([])

    onBeforeUnmount(periodic(1000, async () => {
      buttons.value = await request<Button[]>('buttons')
    }))

    return {
      t,
      buttons,
      async changeVisibility(button: Button) {
        // eslint-disable-next-line no-param-reassign
        button.visibility = !button.visibility
        await axios.post(`/buttons/${props.scheduleId}/visibility`, {
          id: button.id,
          visibility: button.visibility,
        })
      },
    }
  },
})
